const Settings = {
  CARROT_BACKEND_URL: window.env?.CARROT_BACKEND_URL,
  CARROT_BACKEND_ADMIN_URL: window.env?.CARROT_BACKEND_ADMIN_URL,
  CARROT_ADMIN_V2_URL: window.env?.CARROT_ADMIN_V2_URL,
  SENTRY_URL: window.env?.SENTRY_URL,
  HEAP_ENV_ID: window.env?.HEAP_ENV_ID,
  IVF_TREATMENT_OPTIONS_URL: window.env?.IVF_TREATMENT_OPTIONS_URL,
  CONTENTFUL_SPACE_ID: window.env?.CONTENTFUL_SPACE_ID,
  CONTENTFUL_ACCESS_TOKEN: window.env?.CONTENTFUL_ACCESS_TOKEN,
  CONTENTFUL_PREVIEW_MODE: window.env?.CONTENTFUL_PREVIEW_MODE,
  ZENDESK_GUIDE: window.env?.ZENDESK_GUIDE,
  CARROT_PLANS_CARE_NAV_CHAT_URL: window.env?.CARROT_PLANS_CARE_NAV_CHAT_URL,
  CARROT_PLANS_LGBTQ_FAMILY_CHAT_URL: window.env?.CARROT_PLANS_LGBTQ_FAMILY_CHAT_URL,
  CARROT_PLANS_ADOPTION_CHAT_URL: window.env?.CARROT_PLANS_ADOPTION_CHAT_URL,
  CARROT_PLANS_GESTATIONAL_CARRIER_CHAT_URL: window.env?.CARROT_PLANS_GESTATIONAL_CARRIER_CHAT_URL,
  CARROT_PLANS_FERTILITY_CHAT_URL: window.env?.CARROT_PLANS_FERTILITY_CHAT_URL,
  CARROT_PLANS_PREGNANCY_CHAT_URL: window.env?.CARROT_PLANS_PREGNANCY_CHAT_URL
}

export default Settings
